export default {
  // 按钮文本
  addButton: 'Add',
  editButton: 'Edit',
  deleteButton: 'Delete',
  cancelButton: 'Cancel',
  confirmButton: 'Confirm',

  // 表格列标题
  roleNameColumn: 'Role Name',
  roleKeyColumn: 'Permission Key',
  useTypeColumn: 'Use Type',
  statusColumn: 'Status',
  createTimeColumn: 'Create Time',
  actionColumn: 'Action',

  // 使用类型
  useTypePc: 'PC',
  useTypeMobile: 'Mobile',

  // 状态
  statusNormal: 'Normal',
  statusDisabled: 'Disabled',
  statusYes: 'Yes',
  statusNo: 'No',

  // 表单标签
  roleNameLabel: 'Role Name',
  roleKeyLabel: 'Permission Key',
  orderNumLabel: 'Role Order',
  useTypeLabel: 'Use Type',
  statusLabel: 'Status',
  menuPermsLabel: 'Menu Permissions',

  // 表单placeholder
  roleNamePlaceholder: 'Please enter role name',
  roleKeyPlaceholder: 'Please enter permission key',
  orderNumPlaceholder: 'Enter sort order',

  // 验证消息
  roleNameRequired: 'Please enter role name',
  roleKeyRequired: 'Please enter permission key',
  orderNumRequired: 'Please enter sort order',
  useTypeRequired: 'Please select use type',
  statusRequired: 'Please select status',

  // 弹窗标题
  addRoleTitle: 'Add Role',
  editRoleTitle: 'Edit Role',

  // 确认对话框
  deleteConfirm: 'Delete {name}?',

  // 成功消息
  addSuccess: 'Added successfully',
  editSuccess: 'Modified successfully',
  deleteSuccess: 'Deleted successfully',
}
